export default "/KeyArt_landscape.7d5800e1-c41fc5.png";